import { LoadingStatusEnum } from '../../../constants/enums';

export const initialState = {
  list: [],
  loading: LoadingStatusEnum.Idle,
};
